import { StaffExpensesSalaryIdsInput } from '../../lib/types/models/travel-expenses/travel-expenses'
import { downloadDocuments } from '../../lib/utils/files/download-documents'
import { API } from '../apis.config'

export const printStaffsExpensesSalaries = async (input: StaffExpensesSalaryIdsInput) => {
  return downloadDocuments<StaffExpensesSalaryIdsInput>({
    data: input,
    endpoint: API.travelExpenses.printStaffsExpensesSalaries.url
  })
}
